import React from "react";
import "./LandingPageStyle.scss";
import BannerSection from "../../components/BannerSection";
import ContactUsSection from "../../components/ContactUsSection";
import MainLayout from "../../components/MainLayout";
import ProvidersSection from "../../components/ProvidersSection";
import EventSection from "../../components/EventSection";
import AboutUsSection from "../../components/AboutUsSection";
import CertifiedSection from "../../components/CertifiedSection";
import TestimonialsSection from "../../components/TestimonialsSection";
import SlotGamesSection from "../../components/SlotGamesSection";
import FastGamesSection from "../../components/FastGamesSection";

const LandingPage = () => {
  return (
    <>
      <MainLayout>
        <div className="landing-page">
          <BannerSection />
          <ProvidersSection />
          <EventSection />
          <AboutUsSection />
          <SlotGamesSection />
          {/* <FastGamesSection /> */}
          <CertifiedSection />
          <TestimonialsSection />
          <ContactUsSection />
        </div>
      </MainLayout>
    </>
  );
};

export default LandingPage;
